const wishlistStyles = {
  'joy-wishlist-icon': 'button svg path{fill:none!important;stroke:#fff!important;stroke-width:1.8!important}.Joy-Wishlist-AccessButton__AddedItem{background:#fff!important;color:#111!important}',
  'joy-wishlist-button[type="product"]': 'button.Joy-Wishlist__Button{min-height:44px!important;padding:8px 14px!important;border:1px solid #111!important;background:transparent!important;color:#111!important;box-shadow:none!important}button.Joy-Wishlist__Button:hover{background:#f5f5f5!important}button.Joy-Wishlist__Button svg path{fill:none!important;stroke:#111!important}.Joy-Wishlist-WishlistButton__Icon,.Joy-Wishlist-WishlistButton__Text{color:#111!important}'
};

function polishWishlist() {
  for (const [selector, css] of Object.entries(wishlistStyles)) {
    for (const element of document.querySelectorAll(selector)) {
      const root = element.shadowRoot;
      if (!root || element.dataset.nwlyPolished === 'true') continue;
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      element.dataset.nwlyPolished = 'true';
    }
  }
}

const wishlistObserver = new MutationObserver(polishWishlist);
wishlistObserver.observe(document.documentElement, { childList: true, subtree: true });
polishWishlist();
const wishlistCheck = setInterval(polishWishlist, 500);
setTimeout(() => clearInterval(wishlistCheck), 30000);
